document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    if (!document.documentElement.classList.contains("shopify-design-mode")) {
        // Global
        imageFade(".coImageFade");
        textFade(".coTextFade");
        simpleFade(".coItemFade");
        imageParallax();





      
      


      
        // Home Page
        // Hero
        // slideUp('.co-home-s1 .co-heading', 0.5);
        // slideUp('.co-home-s1 .co-richtext', 0.8);
        // slideUp('.co-home-s1 .co-btn-1', 1.1);
        // slideUp('.co-home-s1 .co-btn-2', 1.4);
        // var homeSec1 = document.querySelector('.co-home-s1');
        // if (homeSec1) {
        //     slideDown('.header-wrapper', 1.6);
        //     slideDown('.utility-bar', 1.6);
        // }
        // zoomDown('.co-home-s1_imagebg .z-img-desktop', 0, 1.1);
        // zoomDown('.co-home-s1_imagebg .z-img-mob', 0, 1.1);

        // Sec 2

        // Sec 6
        // let sec6Bullets = document.querySelectorAll('.co-home-s6 .swiper-pagination .swiper-pagination-bullet');
        // sec6Bullets.forEach(function (bulletItem, index) {
        //     let timelineI = gsap.timeline();
        //     gsap.set(bulletItem, { opacity: 0, y: 20 });
        //     timelineI.to(bulletItem, {
        //         duration: 1,
        //         opacity: 1,
        //         y: 0,
        //         ease: "power2.out",
        //         delay: index * 0.1,
        //     });
        //     ScrollTrigger.create({
        //         trigger: bulletItem,
        //         // start: "top 110%",
        //         end: "bottom bottom",
        //         toggleActions: "play none none none",
        //         // toggleActions: "restart none none reverse",
        //         animation: timelineI,
        //     });
        // });

        // // Sec 8
        // let sec8ParallaxTrigger = document.querySelector(
        //     ".co-home-s8"
        // );
        // var sec8Image1 = document.querySelector(".co-home-s8 .co-home-s8-img-1 img");
        // var sec8Image2 = document.querySelector(".co-home-s8 .co-home-s8-img-2 img");
        // var sec8ImageLayer1 = document.querySelector(".co-home-s8 .co-home-s8-img-1");
        // var sec8ImageLayer2 = document.querySelector(".co-home-s8 .co-home-s8-img-2");


        // gsap.set(sec8Image1, { top: "0%", transition: 0 });
        // gsap.to(sec8Image1, {
        //     scrollTrigger: {
        //         trigger: sec8ParallaxTrigger,
        //         start: "top bottom",
        //         end: "bottom top",
        //         scrub: 1,
        //     },
        //     top: "-20%",
        // });

        // gsap.set(sec8Image2, { top: "-20%", transition: 0 });
        // gsap.to(sec8Image2, {
        //     scrollTrigger: {
        //         trigger: sec8ParallaxTrigger,
        //         start: "top bottom",
        //         end: "bottom top",
        //         scrub: 1,
        //     },
        //     top: "0%",
        // });

        // gsap.set(sec8ImageLayer1, { top: "-20%", transition: 0 });
        // gsap.to(sec8ImageLayer1, {
        //     scrollTrigger: {
        //         trigger: sec8ParallaxTrigger,
        //         start: "top bottom",
        //         end: "bottom top",
        //         scrub: 1,
        //     },
        //     top: "0%",
        // });

        // gsap.set(sec8ImageLayer2, { bottom: "0%", transition: 0 });
        // gsap.to(sec8ImageLayer2, {
        //     scrollTrigger: {
        //         trigger: sec8ParallaxTrigger,
        //         start: "top bottom",
        //         end: "bottom top",
        //         scrub: 1,
        //     },
        //     bottom: "20%",
        // });

        // Sec 9
        // let timelineS9 = gsap.timeline();
        // gsap.set('.co-home-s9 .co-home-s9-swiper .swiper-slide', { opacity: 0, y: 30 });
        // timelineS9.to('.co-home-s9 .co-home-s9-swiper .swiper-slide', {
        //     duration: 1,
        //     opacity: 1,
        //     y: 0,
        //     ease: "power2.out",
        //     stagger: 0.2
        // });
        // ScrollTrigger.create({
        //     trigger: '.co-home-s9-swiper',
        //     end: "bottom bottom",
        //     toggleActions: "play none none none",
        //     animation: timelineS9,
        // });

        // Sec 10
         let timelineS10 = gsap.timeline();
         gsap.set('.co-home-s10 .co-home-s10-swiper .swiper-slide', { opacity: 0, y: 30 });
         timelineS10.to('.co-home-s10 .co-home-s10-swiper .swiper-slide', {
             duration: 1,
             opacity: 1,
             y: 0,
             ease: "power2.out",
             stagger: 0.2
         });
         ScrollTrigger.create({
             trigger: '.co-home-s10-swiper',
             end: "bottom bottom",
             toggleActions: "play none none none",
             animation: timelineS10,
         });



         // Process page
         // Sec 1
         zoomDown('.co-process-s1-media img', 0, 1.2);

    }
});

function imageFade(imageQ) {
    let image = document.querySelectorAll(imageQ);
    image.forEach(function (imageItem, index) {
        let timelineI = gsap.timeline();
        gsap.set(imageItem, { opacity: 0, y: 30 });
        timelineI.to(imageItem, {
            duration: 1,
            opacity: 1,
            y: 0,
            ease: "power2.out",
            delay: 0
        });
        ScrollTrigger.create({
            trigger: imageItem,
            // start: "top 110%",
            end: "bottom bottom",
            toggleActions: "play none none none",
            // toggleActions: "restart none none reverse",
            animation: timelineI,
        });
    });
}

function textFade(textQ) {
    let text = document.querySelectorAll(textQ);
    text.forEach(function (textItem, index) {
        let timelineT = gsap.timeline();
        gsap.set(textItem, { opacity: 0, y: 20 });
        timelineT.to(textItem, {
            duration: 1,
            opacity: 1,
            y: 0,
            ease: "power2.out",
            delay: 0,
        });
        ScrollTrigger.create({
            trigger: textItem,
            // start: "top 110%",
            end: "bottom bottom",
            toggleActions: "play none none none",
            // toggleActions: "restart none none reverse",
            animation: timelineT,
        });
    });
}

function simpleFade(itemQ) {
    let item = document.querySelectorAll(itemQ);
    item.forEach(function (Item, index) {
        let timelineS = gsap.timeline();
        gsap.set(Item, { opacity: 0, yPercent: 0 });
        timelineS.to(Item, {
            duration: 1,
            opacity: 1,
            yPercent: 0,
            ease: "power2.out",
            delay: 0,
        });
        ScrollTrigger.create({
            trigger: Item,
            // start: "top 110%",
            end: "bottom bottom",
            toggleActions: "play none none none",
            // toggleActions: "restart none none reverse",
            animation: timelineS,
        });
    });
}

function slideLeft(elQ, delay) {
    let element = document.querySelector(elQ);
    let timelineI = gsap.timeline();
    gsap.set(element, { opacity: 0, x: -30 });
    timelineI.to(element, {
        duration: 1,
        opacity: 1,
        x: 0,
        ease: "power2.out",
        delay: delay,
    });
    ScrollTrigger.create({
        trigger: element,
        // start: "top 110%",
        end: "bottom bottom",
        toggleActions: "play none none none",
        // toggleActions: "restart none none reverse",
        animation: timelineI,
    });
}

function slideUp(elQ, delay) {
    let element = document.querySelector(elQ);
    let timelineI = gsap.timeline();
    gsap.set(element, { opacity: 0, y: 30 });
    timelineI.to(element, {
        duration: 1,
        opacity: 1,
        y: 0,
        ease: "power2.out",
        delay: delay,
    });
    ScrollTrigger.create({
        trigger: element,
        // start: "top 110%",
        end: "bottom bottom",
        toggleActions: "play none none none",
        // toggleActions: "restart none none reverse",
        animation: timelineI,
    });
}

function slideDown(elQ, delay) {
    let element = document.querySelector(elQ);
    let timelineI = gsap.timeline();
    gsap.set(element, { opacity: 0, y: -30 });
    timelineI.to(element, {
        duration: 1,
        opacity: 1,
        y: 0,
        ease: "power2.out",
        delay: delay,
    });
    ScrollTrigger.create({
        trigger: element,
        // start: "top 110%",
        end: "bottom bottom",
        toggleActions: "play none none none",
        // toggleActions: "restart none none reverse",
        animation: timelineI,
    });
}

function zoomDown(elQ, delay, zoomVal) {
    let element = document.querySelector(elQ);
    let timelineI = gsap.timeline();
    gsap.set(element, { opacity: 0, scale: zoomVal });
    timelineI.to(element, {
        duration: 1,
        opacity: 1,
        scale: 1,
        ease: "power2.out",
        delay: delay,
    });
    ScrollTrigger.create({
        trigger: element,
        // start: "top 110%",
        end: "bottom bottom",
        toggleActions: "play none none none",
        // toggleActions: "restart none none reverse",
        animation: timelineI,
    });
}

function imageParallax() {
    let imageParallaxTrigger = document.querySelectorAll(
        ".co-parallax-image--trigger"
    );
    imageParallaxTrigger.forEach(function (imageWrapp) {
        var image = imageWrapp.querySelectorAll(".co-parallax-image img");

        gsap.set(image, { top: "-20%", transition: 0 });
        gsap.to(image, {
            scrollTrigger: {
                trigger: imageParallaxTrigger,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
            },
            top: "0%",
        });
    });
}